import { AnimatePresence } from "framer-motion";
import { Route, Routes, useLocation } from "react-router-dom";
import { HomePage } from "./pages/home-page";
import { ContactPage } from "./pages/contactForm";

export const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence>
      <Routes location={location} key={location.pathname}>
        <Route exact path="/" element={<HomePage />} />
        <Route path="/contact-form" element={<ContactPage />} />
      </Routes>
    </AnimatePresence>
  );
};
